import { render, staticRenderFns } from "./RequiredDocuments.vue?vue&type=template&id=f1cc5926&scoped=true"
import script from "./RequiredDocuments.vue?vue&type=script&lang=js"
export * from "./RequiredDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cc5926",
  null
  
)

export default component.exports